import API from 'services/api';

export const getOfficesList = () => {
  return API.get('/api/offices').then(res => res?.data);
};
